import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import ScreenLoader from "../../../components/ScreenLoader";
import ResultBetGameModal from "../../../components/Models/ResultBetGameModal";
import actions from "../../../redux/actions";
import { notifyError, notifySuccess } from "../../../components/ToastContext";

const SMBookMarketTable = ({ data, handleDeleteAction }) => {
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const [showSetResultModal, setShowSetResultModal] = useState(false);
  const [selectedMarketId, setSelectedMarketId] = useState(null);
  const [selectedMarketName, setSelectedMarketName] = useState(null);

  const handleSetResultShow = (MarketId, MarketName) => {
    setSelectedMarketId(MarketId);
    setSelectedMarketName(MarketName);
    setShowSetResultModal(true);
  };

  // const handleDeleteResult = async (MarketId) => {
  //   if (window.confirm("Are you sure you want to delete this result?")) {
  //     try {
  //       const response = await actions.SetSMDeleteResult(MarketId);
  //       if (response?.data?.Status) {
  //         notifySuccess(response.data.Result);
  //       } else {
  //         notifyError(response?.data?.Result || "Failed to delete result.");
  //       }
  //     } catch (error) {
  //       console.error("Error:", error);
  //       notifyError("Something went wrong.");
  //     }
  //   }
  // };

  const handleModalClose = () => {
    setShowSetResultModal(false);
    setSelectedMarketId(null);
    setSelectedMarketName(null);
  };

  return (
    <>
      {/* Modal */}
      {showSetResultModal && (
        <ResultBetGameModal
          MarketId={selectedMarketId}
          MarketName={selectedMarketName}
          showModal={showSetResultModal}
          handleModalClose={handleModalClose}
        />
      )}

      {loader ? (
        <ScreenLoader />
      ) : (
        <div className="card shadow mb-4">
          <div className="table-responsive">
            <table className="table table-bordered dataTable" width="100%">
              <thead>
                <tr className="bg-gray-300">
                  <th>S.No.</th>
                  <th>Market Id</th>
                  <th>Market Name</th>
                  <th>Start Date</th>
                  <th>Result</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {data?.length > 0 ? (
                  data.map((game, index) => (
                    <tr key={game.MarketId} className={index % 2 === 0 ? "even" : "odd"}>
                      <td>{index + 1}</td>
                      <td>{game.MarketId}</td>
                      <td>{game.MarketName}</td>
                      <td>{game.CreatedOn}</td>
                      <td>{game.Result == '' ? 'Running' : game.Result}</td>
                      <td>
                        <button
                          className="custom-grey-btn"
                          onClick={() => navigate(`/matka-booked-bet/${game.MarketId}/${game.MarketName}`)}
                        >
                          Booked
                        </button>
                        {game?.transferCoin === 'False' ? (
                          <button
                            className="custom-grey-btn"
                            onClick={() => handleSetResultShow(game.MarketId, game.MarketName)}
                          >
                            Result
                          </button>
                        ) : (
                          <button
                            className="custom-grey-btn"
                            onClick={() => handleDeleteAction(game.MarketId)}
                          >
                            Reverse
                          </button>
                        )}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5" style={{ textAlign: "center" }}>
                      No Data
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </>
  );
};

export default SMBookMarketTable;
